import AccountSettingsMain from '@Containers/Settings/AccountSettings/AccountSettingsMain/AccountSettingsMain.container';

const AccountSettingsPage: React.FunctionComponent = (): JSX.Element => (
  <AccountSettingsMain />
);

export default AccountSettingsPage;
